(function () {
  const carousel = document.querySelector('.pv-ordinary-hero__carousel');
  if (!carousel) return;

  const slider = carousel.querySelector('[id^="Slider-"]');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const autoplayEnabled = slider?.getAttribute('data-pv-hero-autoplay') === 'true';

  let autoplayTimer = null;
  let lastHandledSlide = null;

  const getSlides = () => carousel.querySelectorAll('.pv-ordinary-hero__slide');

  const findVideo = (slide) => {
    if (!slide) return null;
    return slide.querySelector('video.pv-ordinary-hero__video') || slide.querySelector('video');
  };

  const pauseAll = () => {
    carousel.querySelectorAll('video').forEach((video) => video.pause());
  };

  const slideDurationMs = (slide) => {
    const raw = slide?.dataset?.duration || slider?.dataset?.defaultDuration || '5';
    const seconds = parseInt(raw, 10);
    return Math.max(3, Number.isFinite(seconds) ? seconds : 5) * 1000;
  };

  const playVideoForSlide = (slide) => {
    pauseAll();
    if (!slide || reducedMotion.matches) return;

    const video = findVideo(slide);
    if (!video) return;

    try {
      video.currentTime = 0;
    } catch (e) {
      /* ignore */
    }

    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => {});
    }
  };

  const clearAutoplay = () => {
    clearTimeout(autoplayTimer);
    autoplayTimer = null;
  };

  const scheduleAutoplay = (slide) => {
    clearAutoplay();
    if (!autoplayEnabled || reducedMotion.matches || !slide) return;

    autoplayTimer = setTimeout(() => {
      const nextButton = carousel.querySelector('button[name="next"]');
      if (!nextButton) return;
      // Advance without a bubbling document click (that would close open modals like search)
      if (typeof carousel.onButtonClick === 'function') {
        carousel.onButtonClick({
          currentTarget: nextButton,
          target: nextButton,
          preventDefault() {},
        });
      } else {
        nextButton.dispatchEvent(new MouseEvent('click', { bubbles: false, cancelable: true, view: window }));
      }
    }, slideDurationMs(slide));
  };

  const handleSlide = (slide) => {
    if (!slide || slide === lastHandledSlide) return;
    lastHandledSlide = slide;
    playVideoForSlide(slide);
    scheduleAutoplay(slide);
  };

  const resolveActiveSlide = (hint) => {
    if (hint && carousel.contains(hint)) return hint;

    for (const slide of getSlides()) {
      if (slide.getAttribute('aria-hidden') !== 'true') return slide;
    }

    return getSlides()[0] || null;
  };

  const afterSlideVisibilitySync = (hint) => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        handleSlide(resolveActiveSlide(hint));
      });
    });
  };

  carousel.addEventListener('slideChanged', (event) => {
    afterSlideVisibilitySync(event.detail?.currentElement);
  });

  carousel.querySelectorAll('.slider-counter__link').forEach((link) => {
    link.addEventListener('click', () => {
      clearAutoplay();
      lastHandledSlide = null;
    });
  });

  slider?.addEventListener(
    'scroll',
    () => {
      afterSlideVisibilitySync(null);
    },
    { passive: true }
  );

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      clearAutoplay();
      pauseAll();
    } else {
      afterSlideVisibilitySync(null);
    }
  });

  reducedMotion.addEventListener('change', () => {
    if (reducedMotion.matches) {
      clearAutoplay();
      pauseAll();
    } else {
      afterSlideVisibilitySync(null);
    }
  });

  const boot = () => afterSlideVisibilitySync(getSlides()[0]);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
